import React, { ChangeEvent } from 'react';

interface ComponentDecimalInputProps {
  id: string;
  value: string;
  editable: boolean;
  onChange: (value: string) => void;
  onBlur: () => void;
}

export function ComponentDecimalInput(
  {
    id,
    value,
    editable,
    onChange,
    onBlur,
  } : ComponentDecimalInputProps,
) : JSX.Element {

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {

    const newValue = e.target.value;

    // Check if the input value is empty or a valid decimal number
    if (newValue === '' || /^\d*(\.\d*)?$/.test(newValue)) {
      onChange(newValue);
    }
  };

  return (
    <input
      id={id}
      type="text"
      value={value}
      onChange={handleChange}
      onBlur={onBlur}
      style={{ width: '100%' }}
      readOnly={!editable}
    />
  );
}
